module.exports = ":host ::ng-deep .dz-text {\n  padding-top: 0 !important;\n  top: initial !important; }\n\n:host ::ng-deep .dz-message {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 121px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+tactic-catalog/finalize/import/import.modal.component.scss
// module id = ./src/app/+tactic-catalog/finalize/import/import.modal.component.scss
// module chunks = main